import get from 'lodash/get';
/** import third-party libraries in the section above, Sort Lines Ascending */

export default function selector(state) {
    const activate = get(state, `activate`, void 0);
    const profile = get(state, `profile`, {});
    const draft = activate.draft;
    const isLoading = activate.isLoading;
    const errors = reduceErrorList(activate.errors);
    const showErrors = activate.showErrors;
    const fetchError = activate.fetchError;

    const o = {
        profile,
        draft,
        isLoading,
        errors,
        showErrors,
        fetchError,
    };
    return o;
}

function reduceErrorList(errorList = []) {
    // Input:
    //
    // [{
    //     field: "name"
    //     message: "Name is required"
    //     value: ""
    // },{
    //     field: "iab_categories"
    //     message: "IAB Category must be provided"
    //     value: Array[0]
    // },{
    //     field: "advertiser_domain"
    //     message: "You must provide the advertiser's domain name, e.g. abc.com"
    //     value: ""
    // }]
    //
    // Output:
    //
    // {
    //     advertiser_domain: [ "You must provide the advertiser's domain name, e.g. abc.com" ],
    //     iab_categories: [ "IAB Category must be provided" ],
    //     name: ["Name is required"]
    // }
    return errorList.reduce((accumulator, error) => {
        accumulator[error.field] = accumulator[error.field] || [];
        accumulator[error.field].push(error.message);
        return accumulator;
    }, {});
}
